import { Box, styled } from '@mui/material';

export const Content = styled(Box)({
  display       : 'flex',
  flexDirection : 'column',
  gap           : '15px',
});
